import styled from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'

const Divider = styled.div`
    height: 1px;
    background-color: #E7E7E7;
    margin: 0 2rem;

    @media (min-width: ${TABLET}px) {
        margin: 0 auto;
        max-width: 480px;
    }

    @media (min-width: ${DESKTOP}px) {
        margin: 0 auto;
        max-width: 704px;
    }
`

export default Divider
